const upTools:{} = {};

/**
 * 跳转到新地址
 * @param path
 */
upTools.goPathNewTab = ( path: string ):void => {
    window.open(upTools.check(path,"url")? path : "/#"+path, '_blank');
}

/**
 * 当前页路由跳转
 * @param path
 */
upTools.goPath = (path: string):void=> {
    window.location.href = upTools.check(path,"url")? path : "/#"+path;
}

upTools.check =  (e: string, type:string):boolean => {
    var str:string=e;
    var Expression:string = ""
    if(type=="url"){
        Expression = /http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/;
    }else if(type=="email"){
        Expression = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    }else if(type=="phone"){
        Expression = /^1[3-9]\d{9}$/;
    }else if(type=="password"){
        // 密码正则
        Expression = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/;
    }
    var objExp=new RegExp(Expression);
    if(objExp.test(str)==true){
        return true;
    }else{
        return false;
    }
}

/**
 * 计算还有多少天失效
 * @param date2 证书失效时间  2021-10-25 18:29:59
 */
upTools.getDistanceDays = (date:string):number => {
    var dateBegin = new Date(date); //可以把n1转化成“Mon Oct 25 2021 18:29:59 GMT+0800 (中国标准时间)”
    var date = new Date(); //获取当前时间
    var result = dateBegin.getTime() - date.getTime();

    if(result<=0){
        return 0;
    } else {
        var joinTime = Math.floor(result / (24 * 3600 * 1000));
        console.log(joinTime )
        return joinTime
    }


}

export default upTools;